import { useMemo } from 'react';
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandShortcut } from '@xiltrion/ui/command';
import { useNavigate } from 'react-router';
import { useSession } from '@/app/session';

/** ⌘K command palette. */
export function CommandPalette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const nav = useNavigate();
  const { me, can, canCreateCase, admin, supervisor } = useSession();
  const commands = useMemo(() => [
    { label: 'Nueva solicitud', to: '/pqrs/nueva', keys: 'N', show: canCreateCase },
    { label: 'Ir a la bandeja', to: '/pqrs', keys: 'G I', show: true },
    { label: 'Ir a mis tareas', to: '/tareas', keys: 'G M', show: true },
    { label: 'Ir a asignación', to: '/asignacion', keys: 'G A', show: admin || supervisor },
    { label: 'Casos sin asignar', to: '/asignacion/sin-asignar', keys: '', show: admin || supervisor || !!me?.inTriage },
    { label: 'Abrir diseñador de workflows', to: '/configuracion/workflows', keys: '', show: admin },
    { label: 'Configurar Decision Engine', to: '/configuracion/decision-engine', keys: '', show: can('admin.advanced') },
    { label: 'Plantillas', to: '/configuracion/plantillas', keys: '', show: can('templates.manage') },
    { label: 'Reportes', to: '/reportes', keys: 'G R', show: admin || supervisor || can('reports.read') },
    { label: 'Correos no enviados', to: '/correos-no-enviados', keys: '', show: can('emails.failed') },
  ].filter((c) => c.show), [can, canCreateCase, admin, supervisor, me]);
  const go = (to: string) => { onClose(); nav(to); };
  return (
    <CommandDialog open={open} onOpenChange={(o) => { if (!o) onClose(); }} title="Comandos" description="Busca una acción o una pantalla" className="sm:max-w-[520px]">
      <CommandInput placeholder="¿Qué quieres hacer?" aria-label="Comando" />
      <CommandList>
        <CommandEmpty>Sin comandos</CommandEmpty>
        <CommandGroup heading="Ir a">
          {commands.map((c) => (
            <CommandItem key={c.to} value={c.label} onSelect={() => go(c.to)}>
              {c.label}
              {c.keys && <CommandShortcut>{c.keys}</CommandShortcut>}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
